export * from './swiper/slides-per-view-auto-fix.directive'
